import { render, staticRenderFns } from "./InviteAuth.vue?vue&type=template&id=b47ba56e&"
import script from "./InviteAuth.vue?vue&type=script&lang=ts&"
export * from "./InviteAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports